<template lang="pug">
  div
    server-time-clock
    current-class-application(
      :show-filter="false"
      :init="timeRange"
      :showPage="bookClassConstants.SHOW_PAGE.BOOK_CLASS"
    )
    current-class-application(:showPage="bookClassConstants.SHOW_PAGE.BOOK_CLASS_RECORD")
</template>

<script type="text/javascript">
import ServerTimeClock from '@/components/serverTimeClock';
import bookClassRecord from '@/components/vip/bookClassRecord';
import CurrentClassApplication from '@/components/vip/currentClassApplication';
import bookClassConstants from '@/constants/bookClass.js';
import moment from 'moment';
import { mapState } from 'vuex';

export default {
  name: 'Coupon',

  components: {
    bookClassRecord,
    CurrentClassApplication,
    ServerTimeClock,
  },

  data() {
    return {
      timeRange: null,
      firstLoad: true,
      bookClassConstants: bookClassConstants,
    };
  },
  computed: {
    ...mapState({
      currentTime: state => state.common.currentTime,
    }),
  },
  watch: {
    currentTime(){
      if (this.firstLoad){
        this.firstLoad = false;
        // currentTime 已是台北時間字串，直接以 naive 方式取日期即可。
        // 原本加 '+08:00' 會把它轉成瀏覽器當地時區再輸出日期，
        // 導致 UTC+8 以西的使用者（如美西、英國）算出前一天。
        const start = moment(this.currentTime).format('YYYY-MM-DD');
        const end = moment(this.currentTime).add(31, 'day').format('YYYY-MM-DD');
        // 目前訂課參數
        this.timeRange = { start, end };
      }
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/transition';
</style>
